import { StatusProps } from 'types';

export const RETURN_STATUSES: {
  [key: string]: StatusProps;
  CREATED: StatusProps;
  AWAITING_CUSTOMER_SHIPMENT: StatusProps;
  AWAITING_CUSTOMER_DROPOFF: StatusProps;
  AWAITING_PRODUCT_ARRIVAL: StatusProps;
  PRODUCT_RECEIVED: StatusProps;
  RETURN_CONFIRMED: StatusProps;
  REFUNDED: StatusProps;
  CANCELED: StatusProps;
  REFUND_FAILED: StatusProps;
} = {
  CREATED: {
    value: 'CREATED',
    label: 'Devolução criada',
    storeFilter: true,
    initialStoreFilter: true,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
  AWAITING_CUSTOMER_SHIPMENT: {
    value: 'AWAITING_CUSTOMER_SHIPMENT',
    label: 'Aguardando cliente postar',
    storeFilter: true,
    initialStoreFilter: true,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
  AWAITING_CUSTOMER_DROPOFF: {
    value: 'AWAITING_CUSTOMER_DROPOFF',
    label: 'Aguardando entrega na loja',
    storeFilter: true,
    initialStoreFilter: true,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
  AWAITING_PRODUCT_ARRIVAL: {
    value: 'AWAITING_PRODUCT_ARRIVAL',
    label: 'Aguardando o(s) produto(s)',
    storeFilter: true,
    initialStoreFilter: true,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
  PRODUCT_RECEIVED: {
    value: 'PRODUCT_RECEIVED',
    label: 'Produto(s) recebido(s)',
    storeFilter: true,
    initialStoreFilter: true,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
  RETURN_CONFIRMED: {
    value: 'RETURN_CONFIRMED',
    label: 'Devolução confirmada',
    storeFilter: true,
    initialStoreFilter: true,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
  REFUNDED: {
    value: 'REFUNDED',
    label: 'Estornado',
    storeFilter: true,
    initialStoreFilter: false,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
  CANCELED: {
    value: 'CANCELED',
    label: 'Devolução cancelada',
    storeFilter: true,
    initialStoreFilter: true,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
  REFUND_FAILED: {
    value: 'REFUND_FAILED',
    label: 'Erro no estorno',
    storeFilter: true,
    initialStoreFilter: true,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
};
